<template>
  <div style="padding:40px">
    <v-layout>
      <v-row>
        <v-col cols="12" md="3">
          <v-card class="custom-card">
            <v-card-text>
              <div class="text-center">
                <img
                  :src="require('../../assets/user.png')"
                  height="50"
                  width="50"
                />
              </div>
              <div
                class="text-center mt-2"
                style="font-weight: 600; font-size: 16px"
              >
                {{ storage_fullname }}
              </div>

              <div
                class="text-center"
                style="font-weight: 400; font-size: 14px"
              >
                {{ role.find((x) => x.role_id === storage_role).role_name }}
              </div>

              <div class="mt-5">
                <v-simple-table>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td class="py-3">
                          <div class="label">
                            Username
                          </div>
                          <div>
                            <b>{{ storage_username }}</b>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="py-3">
                          <div class="label">
                            Company
                          </div>
                          <div>
                            <b>PT. Cipta Kridatama</b>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="py-3">
                          <div class="label">
                            Plant
                          </div>
                          <div>
                            <b>{{ storage_departement_id }}</b>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td class="py-3">
                          <div class="label">
                            Email
                          </div>
                          <div>
                            <b>{{ storage_email }}</b>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <div class="text-right mt-5">
                      <v-btn depressed small v-on:click="getModal()">
                        Change Password
                      </v-btn>
                    </div>
                  </template>
                </v-simple-table>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="9">
          <v-row>
            <v-col cols="12" md="6">
              <v-card class="custom-card widget-card">
                <v-card-text>
                  Total Request Today

                  <span class="badge-detail">
                    <v-btn color="primary" depressed rounded small>
                      {{ data_per_day.total }}
                    </v-btn>
                  </span>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card class="custom-card widget-card">
                <v-card-text>
                  Total Request This Month

                  <span class="badge-detail">
                    <v-btn color="primary" depressed rounded small>
                      {{ data_per_month.total }}
                    </v-btn>
                  </span>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-card class="custom-card card-height">
                <v-card-text>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            Plant
                          </th>
                          <th class="text-right">
                            Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in data_per_plant"
                          :key="index"
                        >
                          <td>{{ item.plant_name }}</td>
                          <td class="text-right">{{ item.total }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card class="custom-card card-height">
                <v-card-text>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            Status
                          </th>
                          <th class="text-right">
                            Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in data_per_status"
                          :key="index"
                        >
                          <td>{{ item.status_name }}</td>
                          <td class="text-right">{{ item.total }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card class="custom-card card-height">
                <v-card-text>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            Purchasing Group
                          </th>
                          <th class="text-right">
                            Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in data_per_purchasing"
                          :key="index"
                        >
                          <td>{{ item.purchasing_group_name }}</td>
                          <td class="text-right">{{ item.total }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card class="custom-card card-height">
                <v-card-text>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            Material Group
                          </th>
                          <th class="text-right">
                            Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in data_per_material"
                          :key="index"
                        >
                          <td>{{ item.material_group_name }}</td>
                          <td class="text-right">{{ item.total }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-layout>

    <v-dialog v-model="modal_password" max-width="500px">
      <v-card>
        <v-card-title>
          Change Password
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <div style="padding:10px">
              <label>
                Password
              </label>

              <v-text-field
                label="Password"
                v-model="password"
                placeholder="Enter your password"
                name="password"
                append-icon="lock"
                type="password"
                :rules="rules"
                solo
              />

              <label>
                New Password
              </label>

              <v-text-field
                label="Password"
                v-model="new_password"
                placeholder="Enter new password"
                name="password"
                append-icon="lock"
                type="password"
                :rules="rules"
                solo
              />

              <label>
                Re Password
              </label>

              <v-text-field
                label="Re Password"
                v-model="re_password"
                placeholder="Enter re new password"
                name="password"
                append-icon="lock"
                :rules="rules"
                type="password"
                solo
              />
            </div>

            <div align="right">
              <v-btn color="primary" text @click="modal_password = false">
                Close
              </v-btn>

              <v-btn
                color="primary"
                :loading="loading"
                class="ml-3"
                v-on:click="update_password()"
              >
                Ok
              </v-btn>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "Dashboard",
      title: "Approval Material",
      list_dashboard: [],
      loading: false,
      modal_password: false,
      password: "",
      new_password: "",
      re_password: "",
      rules: [
        (v) => !!v || "Form is required",
        //v => (v && v.length <= 10) || 'This form must be less than 10 characters',
      ],
      role: [
        {
          role_id: "REQ",
          role_name: "Requester",
        },
        {
          role_id: "APP1",
          role_name: "Approval",
        },
        {
          role_id: "CAT",
          role_name: "Catalogier",
        },
        {
          role_id: "ADM",
          role_name: "Administrator",
        },
      ],
      //storage.....................................
      storage_user_id: atob(localStorage.getItem("user_id")),
      storage_username: atob(localStorage.getItem("username")),
      storage_fullname: atob(localStorage.getItem("fullname")),
      storage_company_id: atob(localStorage.getItem("company_id")),
      storage_company_name: atob(localStorage.getItem("company_name")),
      storage_role: atob(localStorage.getItem("role")),
      storage_server: atob(localStorage.getItem("server")),
      storage_departement_id: atob(localStorage.getItem("departement_id")),
      storage_email: atob(localStorage.getItem("email")),

      data_per_plant: {},
      data_per_status: {},
      data_per_purchasing: {},
      data_per_material: {},
      data_per_day: {},
      data_per_month: {},
    }
  },
  mounted() {
    this.getData()
    this.getDataDashboard()
  },
  methods: {
    getData() {
      var self = this
      var url = self.base_url + "dashboard/home"

      self.axios
        .post(url, {
          user_id: self.storage_user_id,
          role: self.storage_role,
        })
        .then(function(response) {
          self.list_dashboard = response.data
        })
    },
    getModal() {
      this.modal_password = true
    },
    update_password() {
      var self = this
      var url = self.base_url + "mail/update_password"
      var password = self.password
      var new_password = self.new_password
      var re_password = self.re_password
      var passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/

      if (self.$refs.form.validate()) {
        if (!passwordRegex.test(new_password)) {
          alert(
            "Password must have at least one letter, one number, one special character, and be at least 8 characters long."
          )
          return false
        }

        if (re_password != new_password) {
          alert("New password should be different than old password")
          return false
        }

        self.axios
          .post(url, {
            password: password,
            new_password: self.new_password,
            user_id: self.storage_user_id,
          })
          .then(function(response) {
            if (response.data == true) {
              alert("Change password successfully, Please Login again ")
              self.modal_password = false
              self.logout()
            } else {
              alert(response.data)
            }
          })
      }
    },
    logout() {
      window.localStorage.clear()

      this.$router.push("/login")
    },
    async getDataDashboard() {
      this.loading = true
      let data = {}

      if (this.storage_role === "ADM") {
        data = {
          role: this.storage_role,
        }
      } else if (this.storage_role === "PROC") {
        this.storage_role = "ADM"
        data = {
          role: this.storage_role,
        }
      } else if (this.storage_role === "REQ") {
        data = {
          role: this.storage_role,
          param: "a.requester",
          val: this.storage_user_id,
        }
      } else if (this.storage_role === "CAT") {
        data = {
          role: this.storage_role,
          param: "a.cataloguer",
          val: this.storage_user_id,
        }
      } else if (this.storage_role === "APP1") {
        data = {
          role: this.storage_role,
          param: "a.approver",
          val: this.storage_user_id,
        }
      }

      const url_data_per_plant =
        this.base_url + "material/getdata/dashboard_per_plant"

      const url_data_per_status =
        this.base_url + "material/getdata/dashboard_per_status"

      const url_data_per_purchasing =
        this.base_url + "material/getdata/dashboard_per_purchasing_group"

      const url_data_per_material =
        this.base_url + "material/getdata/dashboard_per_material_group"

      const url_data_per_day =
        this.base_url + "material/getdata/dashboard_per_day"

      const url_data_per_month =
        this.base_url + "material/getdata/dashboard_per_month"

      const reponse_data_per_plant = await this.axios.post(
        url_data_per_plant,
        data
      )

      const reponse_data_per_status = await this.axios.post(
        url_data_per_status,
        data
      )

      const reponse_data_per_purchasing = await this.axios.post(
        url_data_per_purchasing,
        data
      )

      const reponse_data_per_material = await this.axios.post(
        url_data_per_material,
        data
      )

      const reponse_data_per_day = await this.axios.post(url_data_per_day, data)

      const reponse_data_per_month = await this.axios.post(
        url_data_per_month,
        data
      )

      this.data_per_plant = reponse_data_per_plant.data
      this.data_per_status = reponse_data_per_status.data
      this.data_per_purchasing = reponse_data_per_purchasing.data
      this.data_per_material = reponse_data_per_material.data
      this.data_per_day = reponse_data_per_day.data
      this.data_per_month = reponse_data_per_month.data
      this.loading = false
    },
  },
}
</script>

<style>
.custom-card {
  background-color: #ffffff !important;
  border: #ececec 1px solid !important;
  box-shadow: none !important;
}

.card-height {
  height: 300px;
  overflow-y: auto;
}

.badge-detail {
  float: right;
  margin-top: -4px;
  font-weight: 600;
  margin-right: 5px;
}
</style>
